module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    staticStyle: {
      "width": "1190px",
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "topMenu",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('top-menu', {
    attrs: {
      "flows": _vm.flows,
      "curFlowTit": _vm.curFlowTit,
      "cates": _vm.cates,
      "common": _vm.common,
      "all": _vm.all,
      "cateId": _vm.typeId,
      "curFlowIndex": _vm.curFlowIndex,
      "keywords": _vm.keywords,
      "timeRange": _vm.timeRange
    },
    on: {
      "selectFlow": _vm.selectFlow,
      "selectCate": _vm.selectCate,
      "search": _vm.search
    }
  }), _vm._v(" ")]), _vm._v(" "), _c('el-col', {
    staticClass: "m-t-20",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('router-view')]), _vm._v(" ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b2fad8a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/instance/flow.vue
// module id = 1766
// module chunks = 2